<template>
  <div>
    <v-dialog
      v-model="dialog"
      fullscreen
      eager
      persistent
      scrollable
      max-width="900px"
    >
      <v-card>
        <v-card-title dark class="dialog-header pt-5 pb-5 pl-6">
          <span>IPCR of {{ data && data.name }}</span>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="closeD()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text style="max-height: 900px" class="my-4">
          <v-card>
            <v-row>
              <!-- <v-col cols="12" v-if="isSubmitted">
                <v-stepper alt-labels class="elevation-0">
                  <v-stepper-header>
                    <v-stepper-step
                      step="1"
                      class="pa-5"
                      :complete="assessed_by_status == 2 ? true : false"
                      :rules="[() => assessed_by_status != 3]"
                      color="#6DB249"
                    >
                      {{ assessed_by }}
                      <small>Assessed By<br /> </small>
                    </v-stepper-step>
                    <v-divider></v-divider>
                    <v-stepper-step
                      step="2"
                      class="pa-5"
                      :complete="final_rating_by_status == 2 ? true : false"
                      :rules="[() => final_rating_by_status != 3]"
                      color="#6DB249"
                    >
                      {{ final_rating_by }}
                      <small>Final Rating <br /> </small>
                    </v-stepper-step>
                  </v-stepper-header>
                </v-stepper>
              </v-col> -->
              <v-col cols="8" class="flex-items mt-2">
                <v-tabs v-model="activeTab" color="#519043" align-tabs="left">
                  <v-tab
                    v-for="tab in tabList"
                    :key="tab.id"
                    @change="changeTab(tab)"
                    >{{ tab.name }}</v-tab
                  >
                </v-tabs>
              </v-col>
              <v-spacer></v-spacer>

              <v-col cols="12" class="pt-2 px-4">
                <table v-if="tab != 4 && tab != 5" id="ipcrTable">
                  <tr>
                    <td
                      colspan="2"
                      style="width: 20%"
                      rowspan="2"
                      class="font-weight-bold text-caption"
                      align="center"
                    >
                      Major Final Output(MFO)
                    </td>
                    <td
                      style="width: 20%"
                      rowspan="2"
                      class="font-weight-bold text-caption"
                      align="center"
                    >
                      Success Indicators<br />Target + Measure
                    </td>
                    <td
                      style="width: 20%"
                      rowspan="2"
                      class="font-weight-bold text-caption"
                      align="center"
                    >
                      Actual Accomplishments
                    </td>
                    <td
                      style="width: 20%"
                      colspan="4"
                      class="font-weight-bold text-caption"
                      align="center"
                    >
                      Rating
                    </td>
                    <td
                      style="width: 10%"
                      rowspan="2"
                      class="font-weight-bold text-caption"
                      align="center"
                    >
                      Remarks
                    </td>
                    <td
                      v-if="isEvaluating"
                      rowspan="2"
                      style="width: 20%"
                      class="font-weight-bold text-caption pa-1"
                      align="center"
                    >
                      Action
                    </td>
                  </tr>
                  <tr>
                    <td
                      style="width: 5%"
                      class="font-weight-bold text-caption"
                      align="center"
                    >
                      E
                    </td>
                    <td
                      style="width: 5%"
                      class="font-weight-bold text-caption"
                      align="center"
                    >
                      Q
                    </td>
                    <td
                      style="width: 5%"
                      class="font-weight-bold text-caption"
                      align="center"
                    >
                      T
                    </td>
                    <td
                      style="width: 5%"
                      class="font-weight-bold text-caption"
                      align="center"
                    >
                      A
                    </td>
                  </tr>
                  <tbody
                    v-if="
                      ipcrToView && ipcrToView.func_type != 'Support Function'
                    "
                  >
                    <tr>
                      <td
                        :colspan="!isEvaluating ? 9 : 10"
                        class="text-subtitle-1 text-justify font-weight-bold"
                        style="text-indent: 10px"
                      >
                        {{ ipcrToView && ipcrToView.func_type }}
                        ({{ ipcrToView && ipcrToView.prct_display + "%" }})
                      </td>
                    </tr>
                    <!-- cf insruction / sp research-->
                    <tr>
                      <td
                        :colspan="!isEvaluating ? 9 : 10"
                        align="left"
                        class="text-caption pa-2"
                      >
                        <b v-if="tab == 1"
                          >{{ getCFIntruction.type }} ({{
                            (data.facultyType == "designated"
                              ? getCFIntruction.prct_display
                              : ipcrToView && ipcrToView.prct_display) + "%"
                          }})</b
                        >
                        <b v-if="tab == 2"
                          >{{ getSPResearch.type }}
                          {{
                            data.facultyType == "designated"
                              ? ""
                              : "(" + getSPResearch.prct_display + "%)"
                          }}</b
                        >
                      </td>
                    </tr>
                    <tr
                      v-for="(item, i) in tab == 1
                        ? getCFIntruction.data
                        : tab == 2
                        ? getSPResearch.data
                        : []"
                      :key="item.id"
                    >
                      <td class="text-caption pa-1" align="center">
                        <!-- {{
                          ipcrToView.func_type == "Core Function"
                            ? "CF" + (i + 1)
                            : ipcrToView.func_type == "Strategic Priority"
                            ? "SP" + (i + 1)
                            : null
                        }} -->
                        {{
                          tab == 1
                            ? "CF" + (i + 1)
                            : tab == 2
                            ? "SP" + (i + 1)
                            : null
                        }}
                      </td>
                      <td class="text-caption pa-1" align="left">
                        {{ item.mfo }}
                      </td>
                      <td class="text-caption pa-1" align="left">
                        {{ item.success_indicator }}
                      </td>
                      <td class="text-caption" align="center">
                        {{ item.actual_accomplishment }}
                      </td>
                      <td class="text-caption" align="center">
                        <div>
                          <div>{{ item.e_avg }}</div>
                          <div
                            v-if="item.hasEvaluation"
                            class="green white--text"
                          >
                            {{ item.evaluation.efficiency }}
                          </div>
                          <div
                            v-if="item.hasReview && moduleFrom == 'Review'"
                            class="light-blue darken-1 white--text"
                          >
                            {{ item.review.efficiency }}
                          </div>
                        </div>
                      </td>
                      <td class="text-caption" align="center">
                        <div>
                          <div>{{ item.q_avg }}</div>
                          <div
                            v-if="item.hasEvaluation"
                            class="green white--text"
                          >
                            {{ item.evaluation.quality }}
                          </div>
                          <div
                            v-if="item.hasReview && moduleFrom == 'Review'"
                            class="light-blue darken-1 white--text"
                          >
                            {{ item.review.quality }}
                          </div>
                        </div>
                      </td>
                      <td class="text-caption" align="center">
                        <div>
                          <div>{{ item.t_avg }}</div>
                          <div
                            v-if="item.hasEvaluation"
                            class="green white--text"
                          >
                            {{ item.evaluation.timeliness }}
                          </div>
                          <div
                            v-if="item.hasReview && moduleFrom == 'Review'"
                            class="light-blue darken-1 white--text"
                          >
                            {{ item.review.timeliness }}
                          </div>
                        </div>
                      </td>
                      <td class="text-caption pa-1" align="center">
                        <div>
                          <div>
                            {{ formatNumberValue(item.a_avg, 2) }}

                            <b v-if="tab == 1">{{ " | " + item.a_avg_prct }}</b
                            ><i v-if="tab == 1">{{
                              " (" + item.prct * 100 + "%)"
                            }}</i>
                          </div>
                          <div
                            v-if="item.hasEvaluation"
                            class="green white--text"
                          >
                            {{ formatNumberValue(computeAvg(item), 2) }}

                            {{
                              tab == 1
                                ? " | " +
                                  formatNumberValue(
                                    computeAvg(item, item.prct),
                                    2
                                  )
                                : null
                            }}
                          </div>
                          <div
                            v-if="item.hasReview && moduleFrom == 'Review'"
                            class="light-blue darken-1 white--text"
                          >
                            {{ formatNumberValue(computeReviewAvg(item), 2) }}

                            {{
                              tab == 1
                                ? " | " +
                                  formatNumberValue(
                                    computeReviewAvg(item, item.prct),
                                    2
                                  )
                                : null
                            }}
                          </div>
                        </div>
                      </td>
                      <td class="text-caption">
                        <div>
                          <div class="pa-1">{{ item.remarks }}</div>
                          <div
                            v-if="item.hasEvaluation"
                            class="green white--text pa-1"
                          >
                            {{ item.evaluation.remarks }}
                          </div>
                          <div
                            v-if="item.hasReview && moduleFrom == 'Review'"
                            class="light-blue darken-1 white--text white--text"
                          >
                            {{ item.review.remarks }}
                          </div>
                        </div>
                      </td>
                      <td
                        v-if="isEvaluating"
                        class="text-caption"
                        style="padding: 10px"
                        align="center"
                      >
                        <v-btn
                          x-small
                          color="warning"
                          @click="
                            add_evaluation(
                              tab == 1
                                ? getCFIntruction.type
                                : tab == 2
                                ? getSPResearch.type
                                : null,
                              item,
                              i
                            )
                          "
                          class="white-text"
                          >{{ getAddEvaluationBtnText(item) }} evaluation</v-btn
                        >
                      </td>
                    </tr>
                    <!-- end of cf insruction /sp research-->
                    <!-- cf designatin\on -->
                    <tr>
                      <td
                        :colspan="!isEvaluating ? 9 : 10"
                        align="left"
                        class="text-caption pa-2"
                      >
                        <b v-if="tab == 1 && data.facultyType == 'designated'"
                          >{{ getCFDesignation.type }} ({{
                            getCFDesignation.prct_display + "%"
                          }})</b
                        >
                        <b v-if="tab == 2"
                          >{{ getSPExtension.type }}
                          {{
                            data.facultyType == "designated"
                              ? ""
                              : "(" + getSPExtension.prct_display + "%)"
                          }}</b
                        >
                      </td>
                    </tr>
                    <tr
                      v-for="(item, i) in tab == 1 &&
                      data.facultyType == 'designated'
                        ? getCFDesignation.data
                        : tab == 2
                        ? getSPExtension.data
                        : null"
                      :key="item.id"
                    >
                      <td class="text-caption pa-1" align="center">
                        {{
                          tab == 1
                            ? "CF" + (getCFIntruction.data.length + i + 1)
                            : tab == 2
                            ? "SP" + (getSPResearch.data.length + i + 1)
                            : null
                        }}
                      </td>
                      <td class="text-caption pa-1" align="left">
                        {{ item.mfo }}
                      </td>
                      <td class="text-caption pa-1" align="left">
                        {{ item.success_indicator }}
                      </td>
                      <td class="text-caption" align="center">
                        {{ item.actual_accomplishment }}
                      </td>
                      <td class="text-caption" align="center">
                        <div>
                          <div>{{ item.e_avg }}</div>
                          <div
                            v-if="item.hasEvaluation"
                            class="green white--text"
                          >
                            {{ item.evaluation.efficiency }}
                          </div>
                          <div
                            v-if="item.hasReview && moduleFrom == 'Review'"
                            class="light-blue darken-1 white--text"
                          >
                            {{ item.review.efficiency }}
                          </div>
                        </div>
                      </td>
                      <td class="text-caption" align="center">
                        <div>
                          <div>{{ item.q_avg }}</div>
                          <div
                            v-if="item.hasEvaluation"
                            class="green white--text"
                          >
                            {{ item.evaluation.quality }}
                          </div>
                          <div
                            v-if="item.hasReview && moduleFrom == 'Review'"
                            class="light-blue darken-1 white--text"
                          >
                            {{ item.review.quality }}
                          </div>
                        </div>
                      </td>
                      <td class="text-caption" align="center">
                        <div>
                          <div>{{ item.t_avg }}</div>
                          <div
                            v-if="item.hasEvaluation"
                            class="green white--text"
                          >
                            {{ item.evaluation.timeliness }}
                          </div>
                          <div
                            v-if="item.hasReview && moduleFrom == 'Review'"
                            class="light-blue darken-1 white--text"
                          >
                            {{ item.review.timeliness }}
                          </div>
                        </div>
                      </td>

                      <td class="text-caption pa-1" align="center">
                        <div>
                          <div>
                            {{ formatNumberValue(item.a_avg, 2) }}
                          </div>
                          <div
                            v-if="item.hasEvaluation"
                            class="green white--text"
                          >
                            {{ formatNumberValue(computeAvg(item), 2) }}
                          </div>
                          <div
                            v-if="item.hasReview && moduleFrom == 'Review'"
                            class="light-blue darken-1 white--text"
                          >
                            {{ formatNumberValue(computeReviewAvg(item), 2) }}
                          </div>
                        </div>
                      </td>
                      <td class="text-caption" align="center">
                        <div>
                          <div>{{ item.remarks }}</div>
                          <div
                            v-if="item.hasEvaluation"
                            class="green white--text"
                          >
                            {{ item.evaluation.remarks }}
                          </div>
                          <div
                            v-if="item.hasReview && moduleFrom == 'Review'"
                            class="light-blue darken-1 white--text"
                          >
                            {{ item.review.remarks }}
                          </div>
                        </div>
                      </td>
                      <td
                        v-if="isEvaluating"
                        class="text-caption"
                        style="padding: 10px"
                        align="center"
                      >
                        <v-btn
                          x-small
                          color="warning"
                          @click="
                            add_evaluation(
                              tab == 1 && data.facultyType == 'designated'
                                ? getCFDesignation.type
                                : tab == 2
                                ? getSPExtension.type
                                : null,
                              item,
                              i
                            )
                          "
                          class="white-text"
                          >{{ getAddEvaluationBtnText(item) }} evaluation</v-btn
                        >
                      </td>
                    </tr>
                    <!-- end of cf designation -->
                    <tr>
                      <td colspan="7" align="right" class="text-caption pa-2">
                        Total {{ ipcrToView.func_type }}
                      </td>
                      <td align="center" class="text-caption pa-2">
                        <div
                          class="d-flex justify-space-between align-center"
                          v-if="tab == 1 && data.facultyType == 'designated'"
                        >
                          <div>Instruction</div>
                          <div>
                            <div class="font-weight-bold">
                              {{ getSubTotal.instruction }}
                            </div>
                            <div
                              class="font-weight-bold green white--text px-1"
                            >
                              {{
                                formatNumberValue(
                                  getEvaluationCF.instruction,
                                  2
                                )
                              }}
                            </div>
                            <div
                              v-if="moduleFrom == 'Review'"
                              class="light-blue darken-1 white--text"
                            >
                              {{
                                formatNumberValue(getReviewCF.instruction, 2)
                              }}
                            </div>
                          </div>
                        </div>
                        <div
                          class="d-flex justify-space-between align-center"
                          v-if="tab == 1 && data.facultyType == 'designated'"
                        >
                          <div>Designation</div>
                          <div>
                            <div class="font-weight-bold">
                              {{ getSubTotal.designation }}
                            </div>
                            <div
                              class="font-weight-bold green white--text px-1"
                            >
                              {{
                                formatNumberValue(
                                  getEvaluationCF.designation,
                                  2
                                )
                              }}
                            </div>
                            <div
                              v-if="moduleFrom == 'Review'"
                              class="light-blue darken-1 white--text"
                            >
                              {{
                                formatNumberValue(getReviewCF.designation, 2)
                              }}
                            </div>
                          </div>
                        </div>
                        <div
                          class="d-flex justify-center"
                          v-if="tab == 1 && data.facultyType != 'designated'"
                        >
                          <div>
                            <div class="font-weight-bold">
                              {{ getSubTotal.instruction_non_designated }}
                            </div>
                            <div
                              class="font-weight-bold green white--text px-1"
                            >
                              {{
                                formatNumberValue(
                                  getEvaluationCF.instruction,
                                  2
                                )
                              }}
                            </div>
                            <div
                              v-if="moduleFrom == 'Review'"
                              class="light-blue darken-1 white--text"
                            >
                              {{
                                formatNumberValue(getReviewCF.instruction, 2)
                              }}
                            </div>
                          </div>
                        </div>
                        <div
                          class="d-flex justify-center"
                          v-if="tab == 2 && data.facultyType == 'designated'"
                        >
                          <div>
                            <div class="font-weight-bold">
                              {{ getSubTotal.researchAndExtension }}
                            </div>
                            <div
                              class="font-weight-bold green white--text px-1"
                            >
                              {{
                                formatNumberValue(
                                  getEvaluationSP.researchAndExtension,
                                  2
                                )
                              }}
                            </div>
                            <div
                              v-if="moduleFrom == 'Review'"
                              class="light-blue darken-1 white--text"
                            >
                              {{
                                formatNumberValue(
                                  getReviewSP.researchAndExtension,
                                  2
                                )
                              }}
                            </div>
                          </div>
                        </div>
                        <div
                          class="d-flex justify-space-between align-center"
                          v-if="tab == 2 && data.facultyType != 'designated'"
                        >
                          <div>Research</div>
                          <div>
                            <div class="font-weight-bold">
                              {{ getSubTotal.research }}
                            </div>
                            <div
                              class="font-weight-bold green white--text px-1"
                            >
                              {{
                                formatNumberValue(getEvaluationSP.research, 2)
                              }}
                            </div>
                            <div
                              v-if="moduleFrom == 'Review'"
                              class="light-blue darken-1 white--text"
                            >
                              {{ formatNumberValue(getReviewSP.research, 2) }}
                            </div>
                          </div>
                        </div>
                        <div
                          class="d-flex justify-space-between align-center"
                          v-if="tab == 2 && data.facultyType != 'designated'"
                        >
                          <div>Extension</div>
                          <div>
                            <div class="font-weight-bold">
                              {{ getSubTotal.extension }}
                            </div>
                            <div
                              class="font-weight-bold green white--text px-1"
                            >
                              {{
                                formatNumberValue(getEvaluationSP.extension, 2)
                              }}
                            </div>
                            <div
                              v-if="moduleFrom == 'Review'"
                              class="light-blue darken-1 white--text"
                            >
                              {{ formatNumberValue(getReviewSP.extension, 2) }}
                            </div>
                          </div>
                        </div>
                      </td>
                      <td class="text-caption"></td>
                      <td class="text-caption" v-if="isEvaluating"></td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td
                        :colspan="!isEvaluating ? 9 : 10"
                        class="text-subtitle-1 text-justify font-weight-bold"
                        style="text-indent: 10px"
                      >
                        {{ ipcrToView && ipcrToView.func_type }} ({{
                          ipcrToView && ipcrToView.prct_display + "%"
                        }})
                      </td>
                    </tr>

                    <tr
                      v-for="(item, i) in getSFInstOblig.data"
                      :key="item.supportId + i"
                    >
                      <td
                        v-if="i == 0"
                        :rowspan="getSFInstOblig.data.length"
                        class="text-caption pa-1"
                        align="center"
                      >
                        SF1
                      </td>
                      <td
                        v-if="i == 0"
                        :rowspan="getSFInstOblig.data.length"
                        class="text-caption pa-1"
                        align="left"
                      >
                        {{ item.mfo }}
                      </td>
                      <td class="text-caption pa-1" align="left">
                        {{ item.success_indicator }}
                      </td>
                      <td class="text-caption" align="center">
                        {{ item.actual_accomplishment }}
                      </td>
                      <td class="text-caption" align="center">
                        <div>
                          <div>{{ item.e_avg }}</div>
                          <div
                            v-if="item.hasEvaluation"
                            class="green white--text"
                          >
                            {{ item.evaluation.efficiency }}
                          </div>
                          <div
                            v-if="item.hasReview && moduleFrom == 'Review'"
                            class="light-blue darken-1 white--text"
                          >
                            {{ item.review.efficiency }}
                          </div>
                        </div>
                      </td>
                      <td class="text-caption" align="center">
                        <div>
                          <div>{{ item.q_avg }}</div>
                          <div
                            v-if="item.hasEvaluation"
                            class="green white--text"
                          >
                            {{ item.evaluation.quality }}
                          </div>
                          <div
                            v-if="item.hasReview && moduleFrom == 'Review'"
                            class="light-blue darken-1 white--text"
                          >
                            {{ item.review.quality }}
                          </div>
                        </div>
                      </td>
                      <td class="text-caption" align="center">
                        <div>
                          <div>{{ item.t_avg }}</div>
                          <div
                            v-if="item.hasEvaluation"
                            class="green white--text"
                          >
                            {{ item.evaluation.timeliness }}
                          </div>
                          <div
                            v-if="item.hasReview && moduleFrom == 'Review'"
                            class="light-blue darken-1 white--text"
                          >
                            {{ item.review.timeliness }}
                          </div>
                        </div>
                      </td>
                      <td class="text-caption" align="center">
                        <div>
                          <div>{{ item.a_avg }}</div>
                          <div
                            v-if="item.hasEvaluation"
                            class="green white--text"
                          >
                            {{ formatNumberValue(computeAvg(item), 2) }}
                          </div>
                          <div
                            v-if="item.hasReview && moduleFrom == 'Review'"
                            class="light-blue darken-1 white--text"
                          >
                            {{ formatNumberValue(computeReviewAvg(item), 2) }}
                          </div>
                        </div>
                      </td>
                      <td class="text-caption" align="center">
                        <div>
                          <div>{{ item.remarks }}</div>
                          <div
                            v-if="item.hasEvaluation"
                            class="green white--text"
                          >
                            {{ item.evaluation.remarks }}
                          </div>
                          <div
                            v-if="item.hasReview && moduleFrom == 'Review'"
                            class="light-blue darken-1 white--text"
                          >
                            {{ item.review.remarks }}
                          </div>
                        </div>
                      </td>
                      <td
                        v-if="isEvaluating"
                        class="text-caption"
                        style="padding: 10px"
                        align="center"
                      >
                        <v-btn
                          x-small
                          color="warning"
                          @click="
                            add_evaluation('Institutional Obligations', item, i)
                          "
                          class="white-text"
                          >{{ getAddEvaluationBtnText(item) }} evaluation</v-btn
                        >
                      </td>
                    </tr>
                    <tr
                      v-for="(item, i) in getProfDev.data"
                      :key="item.supportId"
                    >
                      <td class="text-caption pa-1" align="center">
                        SF {{ i + 2 }}
                      </td>
                      <td
                        v-if="i == 0"
                        :rowspan="getProfDev.data.length"
                        class="text-caption pa-1"
                        align="left"
                      >
                        {{ item.mfo }}
                      </td>
                      <td class="text-caption pa-1" align="left">
                        {{ item.success_indicator }}
                      </td>
                      <td
                        class="text-caption preserve-whitespace pa-2"
                        align="left"
                      >
                        {{ item.actual_accomplishment }}
                      </td>
                      <td class="text-caption" align="center">
                        <div>
                          <div>{{ item.e_avg }}</div>
                          <div
                            v-if="item.hasEvaluation"
                            class="green white--text"
                          >
                            {{ item.evaluation.efficiency }}
                          </div>
                          <div
                            v-if="item.hasReview && moduleFrom == 'Review'"
                            class="light-blue darken-1 white--text"
                          >
                            {{ item.review.efficiency }}
                          </div>
                        </div>
                      </td>
                      <td class="text-caption" align="center">
                        <div>
                          <div>{{ item.q_avg }}</div>
                          <div
                            v-if="item.hasEvaluation"
                            class="green white--text"
                          >
                            {{ item.evaluation.quality }}
                          </div>
                          <div
                            v-if="item.hasReview && moduleFrom == 'Review'"
                            class="light-blue darken-1 white--text"
                          >
                            {{ item.review.quality }}
                          </div>
                        </div>
                      </td>
                      <td class="text-caption" align="center">
                        <div>
                          <div>{{ item.t_avg }}</div>
                          <div
                            v-if="item.hasEvaluation"
                            class="green white--text"
                          >
                            {{ item.evaluation.timeliness }}
                          </div>
                          <div
                            v-if="item.hasReview && moduleFrom == 'Review'"
                            class="light-blue darken-1 white--text"
                          >
                            {{ item.review.timeliness }}
                          </div>
                        </div>
                      </td>
                      <td class="text-caption" align="center">
                        <div>
                          <div>
                            {{
                              !isNaN(item.a_avg)
                                ? formatNumberValue(item.a_avg, 2)
                                : ""
                            }}
                          </div>
                          <div
                            v-if="item.hasEvaluation"
                            class="green white--text"
                          >
                            {{ formatNumberValue(computeAvg(item), 2) }}
                          </div>
                          <div
                            v-if="item.hasReview && moduleFrom == 'Review'"
                            class="light-blue darken-1 white--text"
                          >
                            {{ formatNumberValue(computeReviewAvg(item), 2) }}
                          </div>
                        </div>
                      </td>
                      <td class="text-caption" align="center">
                        <div>
                          <div>{{ item.remarks }}</div>
                          <div
                            v-if="item.hasEvaluation"
                            class="green white--text"
                          >
                            {{ item.evaluation.remarks }}
                          </div>
                          <div
                            v-if="item.hasReview && moduleFrom == 'Review'"
                            class="light-blue darken-1 white--text"
                          >
                            {{ item.review.remarks }}
                          </div>
                        </div>
                      </td>
                      <td
                        v-if="isEvaluating"
                        class="text-caption"
                        style="padding: 10px"
                        align="center"
                      >
                        <v-btn
                          x-small
                          color="warning"
                          @click="
                            add_evaluation('Professional Development', item, i)
                          "
                          class="white-text"
                          >{{ getAddEvaluationBtnText(item) }} evaluation</v-btn
                        >
                      </td>
                    </tr>
                    <tr>
                      <td colspan="7" align="right" class="text-caption pa-1">
                        Total
                      </td>
                      <td class="text-caption pa-1" align="center">
                        <div>
                          <div>{{ getSubTotal.sfTotal }}</div>
                          <div class="font-weight-bold green white--text px-1">
                            {{ formatNumberValue(getEvaluationSF, 2) }}
                          </div>
                          <div
                            v-if="moduleFrom == 'Review'"
                            class="light-blue darken-1 white--text"
                          >
                            {{ formatNumberValue(getReviewSF, 2) }}
                          </div>
                        </div>
                      </td>

                      <td class="text-caption" align="center"></td>
                      <td
                        v-if="isEvaluating"
                        class="text-caption"
                        align="center"
                      ></td>
                    </tr>
                  </tbody>
                </table>
                <table v-if="tab == 4" id="categoryTable">
                  <tr>
                    <td
                      style="width: 20%"
                      class="font-weight-bold text-caption pa-1"
                      align="center"
                    >
                      Category
                    </td>
                    <td
                      style="width: 20%"
                      class="font-weight-bold text-caption"
                      align="center"
                    >
                      Total
                    </td>
                    <td
                      style="width: 20%"
                      class="font-weight-bold text-caption"
                      align="center"
                    >
                      Number of MFO's
                    </td>
                    <td
                      style="width: 20%"
                      class="font-weight-bold text-caption"
                      align="center"
                    >
                      Percentage(%)
                    </td>
                    <td
                      style="width: 20%"
                      class="font-weight-bold text-caption"
                      align="center"
                    >
                      General Average
                    </td>
                  </tr>
                  <tr v-for="(item, i) in category" :key="i">
                    <td
                      align="left"
                      style="text-indent: 10px"
                      class="text-caption pa-1"
                      :colspan="item.cols"
                    >
                      {{ item.type }}
                    </td>
                    <td
                      v-if="item.cols == 1"
                      align="center"
                      class="text-caption"
                    >
                      <div v-if="i == 0" class="pa-2">
                        <div v-if="item.isDesignated">
                          <div class="d-flex justify-space-between">
                            <div><i>Instruction</i></div>
                            <div>
                              <div>
                                {{
                                  formatNumberValue(
                                    item.total_arr.instruction.subT,
                                    2
                                  )
                                }}
                              </div>
                              <div class="green white--text pa-1">
                                {{
                                  formatNumberValue(
                                    getEvaluationCF.instruction,
                                    2
                                  )
                                }}
                              </div>
                              <div
                                v-if="moduleFrom == 'Review'"
                                class="light-blue darken-1 white--text"
                              >
                                {{
                                  formatNumberValue(getReviewCF.instruction, 2)
                                }}
                              </div>
                            </div>
                          </div>
                          <div class="d-flex justify-space-between">
                            <div><i>Designation</i></div>
                            <div>
                              <div>
                                {{
                                  formatNumberValue(
                                    item.total_arr.designation.subT,
                                    2
                                  )
                                }}
                              </div>
                              <div class="green white--text pa-1">
                                {{
                                  formatNumberValue(
                                    getEvaluationCF.designation,
                                    2
                                  )
                                }}
                              </div>
                              <div
                                v-if="moduleFrom == 'Review'"
                                class="light-blue darken-1 white--text"
                              >
                                {{
                                  formatNumberValue(getReviewCF.designation, 2)
                                }}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div v-else>
                          <div class="d-flex justify-center">
                            <div>
                              <div>
                                {{ formatNumberValue(item.subT, 2) }}
                              </div>
                              <div class="green white--text pa-1">
                                {{
                                  formatNumberValue(
                                    getEvaluationCF.instruction,
                                    2
                                  )
                                }}
                              </div>
                              <div
                                v-if="moduleFrom == 'Review'"
                                class="light-blue darken-1 white--text"
                              >
                                {{
                                  formatNumberValue(getReviewCF.instruction, 2)
                                }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div v-if="i == 1" class="pa-2">
                        <div v-if="!item.isDesignated">
                          <div class="d-flex justify-space-between">
                            <div><i>Research</i></div>
                            <div>
                              <div>
                                {{
                                  formatNumberValue(
                                    item.total_arr.research.subT,
                                    2
                                  )
                                }}
                              </div>
                              <div class="green white--text pa-1">
                                {{
                                  formatNumberValue(getEvaluationSP.research, 2)
                                }}
                              </div>
                              <div
                                v-if="moduleFrom == 'Review'"
                                class="light-blue darken-1 white--text"
                              >
                                {{ formatNumberValue(getReviewSP.research, 2) }}
                              </div>
                            </div>
                          </div>
                          <div class="d-flex justify-space-between">
                            <div><i>Extension</i></div>
                            <div>
                              <div>
                                {{
                                  formatNumberValue(
                                    item.total_arr.extension.subT,
                                    2
                                  )
                                }}
                              </div>
                              <div class="green white--text pa-1">
                                {{
                                  formatNumberValue(
                                    getEvaluationSP.extension,
                                    2
                                  )
                                }}
                              </div>
                              <div
                                v-if="moduleFrom == 'Review'"
                                class="light-blue darken-1 white--text"
                              >
                                {{
                                  formatNumberValue(getReviewSP.extension, 2)
                                }}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div v-else>
                          <div>{{ formatNumberValue(item.subT, 2) }}</div>
                          <div class="green white--text pa-1">
                            {{
                              formatNumberValue(
                                getEvaluationSP.researchAndExtension,
                                2
                              )
                            }}
                          </div>
                          <div
                            v-if="moduleFrom == 'Review'"
                            class="light-blue darken-1 white--text"
                          >
                            {{
                              formatNumberValue(
                                getReviewSP.researchAndExtension,
                                2
                              )
                            }}
                          </div>
                        </div>
                      </div>
                      <div v-if="i > 1" class="pa-1">
                        <div>{{ formatNumberValue(item.total, 2) }}</div>
                        <div class="green white--text pa-1">
                          {{ formatNumberValue(getEvaluationSF, 2) }}
                        </div>
                        <div
                          v-if="moduleFrom == 'Review'"
                          class="light-blue darken-1 white--text"
                        >
                          {{ formatNumberValue(getReviewSF, 2) }}
                        </div>
                      </div>
                    </td>
                    <td
                      v-if="item.cols == 1"
                      align="center"
                      class="text-caption"
                    >
                      <div v-if="i == 0" class="pa-2">
                        <div v-if="item.isDesignated">
                          <div class="d-flex justify-space-between">
                            <div><i>Instruction</i></div>
                            <div>
                              {{ item.mfo_cnt_div.instruction }}
                            </div>
                          </div>
                          <div class="d-flex justify-space-between">
                            <div><i>Designation</i></div>
                            <div>
                              {{ item.mfo_cnt_div.designation }}
                            </div>
                          </div>
                        </div>
                        <div v-else>{{ item.mfo_cnt }}</div>
                      </div>
                      <div v-if="i == 1" class="pa-2">
                        <div v-if="!item.isDesignated">
                          <div class="d-flex justify-space-between">
                            <div><i>Research</i></div>
                            <div>
                              {{ item.mfo_cnt_div.research }}
                            </div>
                          </div>
                          <div class="d-flex justify-space-between">
                            <div><i>Extension</i></div>
                            <div>
                              {{ item.mfo_cnt_div.extension }}
                            </div>
                          </div>
                        </div>
                        <div v-else>{{ item.mfo_cnt }}</div>
                      </div>
                      <div v-if="i > 1">
                        {{ item.mfo_cnt }}
                      </div>
                    </td>
                    <td
                      v-if="item.cols == 1"
                      align="center"
                      class="text-caption"
                    >
                      {{ item.percentage }}
                    </td>
                    <td align="center" class="text-caption">
                      <div v-if="i == 0" class="pa-2">
                        <div v-if="item.isDesignated">
                          <div class="d-flex justify-space-between">
                            <div><i>Instruction</i></div>
                            <div>
                              <div>
                                {{
                                  formatNumberValue(
                                    item.total_arr.instruction.subT,
                                    3
                                  ) +
                                  " * " +
                                  item.total_arr.instruction.percent +
                                  " = " +
                                  formatNumberValue(
                                    item.total_arr.instruction.total,
                                    3
                                  )
                                }}
                              </div>
                              <div class="green white--text pa-1">
                                {{
                                  formatNumberValue(
                                    getEvaluationCF.instruction,
                                    3
                                  ) +
                                  " * " +
                                  item.total_arr.instruction.percent +
                                  " = " +
                                  formatNumberValue(
                                    computeEvaluationGenAvg(
                                      getEvaluationCF.instruction,
                                      item.total_arr.instruction.percent
                                    ),
                                    3
                                  )
                                }}
                              </div>
                              <div
                                v-if="moduleFrom == 'Review'"
                                class="light-blue darken-1 white--text"
                              >
                                {{
                                  formatNumberValue(
                                    getReviewCF.instruction,
                                    3
                                  ) +
                                  " * " +
                                  item.total_arr.instruction.percent +
                                  " = " +
                                  formatNumberValue(
                                    computeEvaluationGenAvg(
                                      getReviewCF.instruction,
                                      item.total_arr.instruction.percent
                                    ),
                                    3
                                  )
                                }}
                              </div>
                            </div>
                          </div>
                          <div class="d-flex justify-space-between">
                            <div><i>Designation</i></div>
                            <div>
                              <div>
                                {{
                                  "(" +
                                  formatNumberValue(
                                    item.total_arr.designation.subT,
                                    3
                                  ) +
                                  "/" +
                                  item.mfo_cnt_div.designation +
                                  ") * " +
                                  item.total_arr.designation.percent +
                                  " = " +
                                  formatNumberValue(
                                    item.total_arr.designation.total,
                                    3
                                  )
                                }}
                              </div>
                              <div class="green white--text pa-1">
                                {{
                                  "(" +
                                  formatNumberValue(
                                    getEvaluationCF.designation,
                                    3
                                  ) +
                                  "/" +
                                  item.mfo_cnt_div.designation +
                                  ") * " +
                                  item.total_arr.designation.percent +
                                  " = " +
                                  formatNumberValue(
                                    computeEvaluationGenAvg(
                                      getEvaluationCF.designation /
                                        item.mfo_cnt_div.designation,
                                      item.total_arr.designation.percent
                                    ),
                                    3
                                  )
                                }}
                              </div>
                              <div
                                v-if="moduleFrom == 'Review'"
                                class="light-blue darken-1 white--text"
                              >
                                {{
                                  "(" +
                                  formatNumberValue(
                                    getReviewCF.designation,
                                    3
                                  ) +
                                  "/" +
                                  item.mfo_cnt_div.designation +
                                  ") * " +
                                  item.total_arr.designation.percent +
                                  " = " +
                                  formatNumberValue(
                                    computeEvaluationGenAvg(
                                      getReviewCF.designation /
                                        item.mfo_cnt_div.designation,
                                      item.total_arr.designation.percent
                                    ),
                                    3
                                  )
                                }}
                              </div>
                            </div>
                          </div>
                          <div class="d-flex justify-space-between">
                            <div><i>Total</i></div>
                            <div>
                              <div>
                                {{
                                  "(" + item.percentage + ") " + item.gen_avg
                                }}
                              </div>
                              <div class="green white--text pa-1">
                                {{
                                  "(" +
                                  item.percentage +
                                  ") " +
                                  formatNumberValue(getTotalEvalAvg.cf, 2)
                                }}
                              </div>
                              <div
                                v-if="moduleFrom == 'Review'"
                                class="light-blue darken-1 white--text"
                              >
                                {{
                                  "(" +
                                  item.percentage +
                                  ") " +
                                  formatNumberValue(getTotalReviewAvg.cf, 2)
                                }}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div v-else class="pa-1">
                          <div>
                            {{
                              formatNumberValue(item.subT, 2) +
                              " * " +
                              item.percentage +
                              " = " +
                              formatNumberValue(item.gen_avg, 2)
                            }}
                          </div>
                          <div class="green white--text pa-1">
                            {{
                              getEvaluationCF.instruction +
                              " * " +
                              item.percentage +
                              " = " +
                              formatNumberValue(getTotalEvalAvg.cf, 2)
                            }}
                          </div>
                          <div
                            v-if="moduleFrom == 'Review'"
                            class="light-blue darken-1 white--text"
                          >
                            {{
                              getReviewCF.instruction +
                              " * " +
                              item.percentage +
                              " = " +
                              formatNumberValue(getTotalReviewAvg.cf, 2)
                            }}
                          </div>
                        </div>
                      </div>
                      <div v-if="i == 1" class="pa-2">
                        <div v-if="!item.isDesignated">
                          <div class="d-flex justify-space-between">
                            <div><i>Research</i></div>
                            <div>
                              <div>
                                {{
                                  "(" +
                                  item.total_arr.research.subT +
                                  "/" +
                                  item.mfo_cnt_div.research +
                                  ") * " +
                                  item.total_arr.research.percent +
                                  " = " +
                                  formatNumberValue(
                                    item.total_arr.research.total,
                                    2
                                  )
                                }}
                              </div>
                              <div class="green white--text pa-1">
                                {{
                                  "(" +
                                  getEvaluationSP.research +
                                  "/" +
                                  item.mfo_cnt_div.research +
                                  ") * " +
                                  item.total_arr.research.percent +
                                  " = " +
                                  formatNumberValue(
                                    computeEvaluationGenAvg(
                                      getEvaluationSP.research /
                                        item.mfo_cnt_div.research,
                                      item.total_arr.research.percent
                                    ),
                                    2
                                  )
                                }}
                              </div>
                              <div
                                v-if="moduleFrom == 'Review'"
                                class="light-blue darken-1 white--text"
                              >
                                {{
                                  "(" +
                                  getReviewSP.research +
                                  "/" +
                                  item.mfo_cnt_div.research +
                                  ") * " +
                                  item.total_arr.research.percent +
                                  " = " +
                                  formatNumberValue(
                                    computeEvaluationGenAvg(
                                      getReviewSP.research /
                                        item.mfo_cnt_div.research,
                                      item.total_arr.research.percent
                                    ),
                                    2
                                  )
                                }}
                              </div>
                            </div>
                          </div>
                          <div class="d-flex justify-space-between">
                            <div><i>Extension</i></div>
                            <div>
                              <div>
                                {{
                                  "(" +
                                  item.total_arr.extension.subT +
                                  "/" +
                                  item.mfo_cnt_div.extension +
                                  ") * " +
                                  item.total_arr.extension.percent +
                                  " = " +
                                  formatNumberValue(
                                    item.total_arr.extension.total,
                                    2
                                  )
                                }}
                              </div>
                              <div class="green white--text pa-1">
                                {{
                                  "(" +
                                  getEvaluationSP.extension +
                                  "/" +
                                  item.mfo_cnt_div.extension +
                                  ") * " +
                                  item.total_arr.extension.percent +
                                  " = " +
                                  formatNumberValue(
                                    computeEvaluationGenAvg(
                                      getEvaluationSP.extension /
                                        item.mfo_cnt_div.extension,
                                      item.total_arr.extension.percent
                                    ),
                                    2
                                  )
                                }}
                              </div>
                              <div
                                v-if="moduleFrom == 'Review'"
                                class="light-blue darken-1 white--text"
                              >
                                {{
                                  "(" +
                                  getReviewSP.extension +
                                  "/" +
                                  item.mfo_cnt_div.extension +
                                  ") * " +
                                  item.total_arr.extension.percent +
                                  " = " +
                                  formatNumberValue(
                                    computeEvaluationGenAvg(
                                      getReviewSP.extension /
                                        item.mfo_cnt_div.extension,
                                      item.total_arr.extension.percent
                                    ),
                                    2
                                  )
                                }}
                              </div>
                            </div>
                          </div>
                          <div class="d-flex justify-space-between">
                            <div><i>Total</i></div>
                            <div>
                              <div>
                                {{
                                  "(" + item.percentage + ") " + item.gen_avg
                                }}
                              </div>
                              <div class="green white--text pa-1">
                                {{
                                  "(" +
                                  item.percentage +
                                  ") " +
                                  formatNumberValue(getTotalEvalAvg.sp, 2)
                                }}
                              </div>
                              <div
                                v-if="moduleFrom == 'Review'"
                                class="light-blue darken-1 white--text"
                              >
                                {{
                                  "(" +
                                  item.percentage +
                                  ") " +
                                  formatNumberValue(getTotalReviewAvg.sp, 2)
                                }}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div v-else>
                          <div>{{ item.gen_avg }}</div>
                          <div class="green white--text pa-1">
                            {{ formatNumberValue(getTotalEvalAvg.sp, 2) }}
                          </div>
                          <div
                            v-if="moduleFrom == 'Review'"
                            class="light-blue darken-1 white--text"
                          >
                            {{ formatNumberValue(getTotalReviewAvg.sp, 2) }}
                          </div>
                        </div>
                      </div>

                      <div v-if="i == 2" class="pa-1">
                        <div>{{ item.gen_avg }}</div>
                        <div class="green white--text pa-1">
                          {{ formatNumberValue(getTotalEvalAvg.sf, 2) }}
                        </div>
                        <div
                          v-if="moduleFrom == 'Review'"
                          class="light-blue darken-1 white--text"
                        >
                          {{ formatNumberValue(getTotalReviewAvg.sf, 2) }}
                        </div>
                      </div>
                      <div v-if="i == 3" class="pa-1">
                        <div>{{ item.gen_avg }}</div>
                        <div class="green white--text pa-1">
                          {{
                            formatNumberValue(
                              getTotalEvalAvg.cf +
                                getTotalEvalAvg.sp +
                                getTotalEvalAvg.sf,
                              2
                            )
                          }}
                        </div>
                        <div
                          v-if="moduleFrom == 'Review'"
                          class="light-blue darken-1 white--text"
                        >
                          {{
                            formatNumberValue(
                              getTotalReviewAvg.cf +
                                getTotalReviewAvg.sp +
                                getTotalReviewAvg.sf,
                              2
                            )
                          }}
                        </div>
                      </div>
                      <div v-if="i == 4" class="pa-1">
                        <div>{{ item.gen_avg }}</div>
                        <div class="green white--text pa-1">
                          {{
                            getRatingEquivalent(
                              formatNumberValue(
                                getTotalEvalAvg.cf +
                                  getTotalEvalAvg.sp +
                                  getTotalEvalAvg.sf,
                                2
                              )
                            )
                          }}
                        </div>
                        <div
                          v-if="moduleFrom == 'Review'"
                          class="light-blue darken-1 white--text"
                        >
                          {{
                            getRatingEquivalent(
                              formatNumberValue(
                                getTotalReviewAvg.cf +
                                  getTotalReviewAvg.sp +
                                  getTotalReviewAvg.sf,
                                2
                              )
                            )
                          }}
                        </div>
                      </div>

                      <!-- {{ item.gen_avg }} -->
                    </td>
                  </tr>
                </table>
              </v-col>
              <v-col cols="12" class="pt-2 px-4" v-show="tab == 5">
                <v-data-table
                  :headers="headers"
                  :items="evidenceList"
                  :items-per-page="-1"
                  hide-default-footer
                >
                  <template v-slot:[`item.actions`]="{ item }">
                    <v-btn
                      elevation="2"
                      block
                      color="primary"
                      class="white--text my-1"
                      x-small
                      @click="viewLink(item)"
                    >
                      <v-icon size="14">mdi-eye</v-icon>
                      View Attachment</v-btn
                    >
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-card>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pa-5" v-if="tbl_tab == 1">
          <v-btn
            color="#519043"
            class="white--text"
            @click="bottom_actions = !bottom_actions"
          >
            Actions
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-bottom-sheet v-model="bottom_actions" v-if="tbl_tab == 1">
      <v-card
        class="text-center"
        height="100"
        v-if="moduleFrom == 'Evaluation'"
      >
        <v-card-text class="pa-6 d-flex justify-end">
          <v-btn
            class="white--text"
            color="#519043"
            v-if="!isEvaluating"
            @click="
              isEvaluating = true;
              bottom_actions = false;
            "
          >
            Evaluate
          </v-btn>
          <v-btn
            class="white--text mx-2"
            color="red"
            v-if="isEvaluating"
            @click="confirmSave('Cancel Evaluation')"
            >Cancel Evaluation
          </v-btn>
          <v-btn
            class="white--text"
            color="#519043"
            v-if="isEvaluating"
            @click="confirmSave('Save Evaluation')"
            >Save Evaluation
          </v-btn>

          <v-btn
            class="white--text ml-2"
            color="warning"
            v-if="!isEvaluating && ipcrER_id"
            @click="confirmSave('Submit For Review')"
            >Submit For Review
          </v-btn>
        </v-card-text>
      </v-card>
      <v-card class="text-center" height="100" v-if="moduleFrom == 'Review'">
        <v-card-text class="pa-6 d-flex justify-end">
          <v-btn
            class="white--text"
            color="#519043"
            v-if="!isEvaluating"
            @click="
              isEvaluating = true;
              bottom_actions = false;
            "
          >
            Evaluate
          </v-btn>
          <v-btn
            class="white--text mx-2"
            color="red"
            v-if="isEvaluating"
            @click="confirmSave('Cancel Evaluation')"
            >Cancel Evaluation
          </v-btn>
          <v-btn
            class="white--text"
            color="#519043"
            v-if="isEvaluating"
            @click="confirmSave('Save Evaluation')"
            >Save Evaluation
          </v-btn>
          <v-btn
            class="white--text ml-2"
            color="warning"
            @click="confirmSave('Submit As Reviewed')"
            >Submit As Reviewed
          </v-btn>
        </v-card-text>
      </v-card>
    </v-bottom-sheet>

    <v-dialog
      v-model="addEvalDialog"
      persistent
      eager
      scrollable
      max-width="600px"
    >
      <v-form ref="AddEvalFormRef" @submit.prevent>
        <v-card>
          <v-card-title dark class="dialog-header pt-2 pb-2 pl-6">
            <span>Set Evaluation</span>
            <v-spacer></v-spacer>
            <v-btn icon dark @click="closeEvalDialog()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text style="max-height: 700px" class="my-2">
            <v-container>
              <v-row>
                <v-col cols="4">
                  <v-text-field
                    outlined
                    label="Efficiency"
                    dense
                    :disabled="eval_efficiency_rated"
                    type="number"
                    v-model="eval_efficiency"
                    :rules="
                      !eval_efficiency_rated
                        ? [formRules.numberNotAboveFiveOrBelowZero]
                        : []
                    "
                    class="rounded-lg"
                    color="#6DB249"
                  ></v-text-field>
                </v-col>
                <v-col cols="4">
                  <v-text-field
                    outlined
                    label="Quality"
                    dense
                    type="number"
                    :disabled="eval_quality_rated"
                    v-model="eval_quality"
                    :rules="
                      !eval_quality_rated
                        ? [formRules.numberNotAboveFiveOrBelowZero]
                        : []
                    "
                    class="rounded-lg"
                    color="#6DB249"
                  ></v-text-field>
                </v-col>
                <v-col cols="4">
                  <v-text-field
                    outlined
                    label="Timeliness"
                    dense
                    :disabled="eval_timeliness_rated"
                    type="number"
                    v-model="eval_timeliness"
                    :rules="
                      !eval_timeliness_rated
                        ? [formRules.numberNotAboveFiveOrBelowZero]
                        : []
                    "
                    class="rounded-lg"
                    color="#6DB249"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-textarea
                    outlined
                    label="Remarks"
                    dense
                    v-model="eval_remarks"
                    class="rounded-lg"
                    color="#6DB249"
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>

          <v-card-actions class="pa-4">
            <v-spacer></v-spacer>

            <v-btn color="red" outlined @click="closeEvalDialog()">
              <v-icon>mdi-close-circle-outline</v-icon>
              Cancel
            </v-btn>

            <v-btn
              color="#519043"
              class="white--text"
              @click="saveEval()"
              :disabled="isSubmitLoading"
              :loading="isSubmitLoading"
            >
              <v-icon>mdi-check-circle</v-icon>
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <WarningDialog
      :msg="warningMsg"
      v-on:yes="yes"
      v-on:no="no"
      :loading="btnLoading"
    />

    <fade-away-message-component
      displayType="variation2"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :top="fadeAwayMessage.top"
      :type="fadeAwayMessage.type"
    ></fade-away-message-component>
  </div>
</template>

<script>
import WarningDialog from "../../Views/WarningDialog.vue";

export default {
  components: {
    WarningDialog,
  },
  props: {
    data: null,
    tbl_tab: null,
    moduleFrom: null,
  },

  computed: {
    shouldPreventRefresh() {
      return this.addedEvaluations.length > 0;
    },

    getTotalEvalAvg() {
      let cf = 0;
      let sp = 0;
      let sf = 0;
      let isDesignated = this.category[0].isDesignated;
      if (isDesignated) {
        cf = this.computeEvaluationGenAvg(
          this.computeEvaluationGenAvg(
            this.getEvaluationCF.instruction,
            this.category[0].total_arr.instruction.percent
          ) +
            this.computeEvaluationGenAvg(
              this.getEvaluationCF.designation /
                this.category[0].mfo_cnt_div.designation,
              this.category[0].total_arr.designation.percent
            ),
          this.category[0].percentage
        );
        sp = this.computeEvaluationGenAvg(
          this.getEvaluationSP.researchAndExtension / this.category[1].mfo_cnt,
          this.category[1].percentage
        );
        sf = this.computeEvaluationGenAvg(
          this.getEvaluationSF / this.category[2].mfo_cnt,
          this.category[2].percentage
        );
      } else {
        cf = this.computeEvaluationGenAvg(
          this.getSubTotal.instruction_non_designated,
          this.category[0].percentage
        );
        sp =
          this.computeEvaluationGenAvg(
            this.getEvaluationSP.research /
              this.category[1].mfo_cnt_div.research,
            this.category[1].total_arr.research.percent
          ) +
          this.computeEvaluationGenAvg(
            this.getEvaluationSP.extension /
              this.category[1].mfo_cnt_div.extension,
            this.category[1].total_arr.extension.percent
          );
        sf = this.computeEvaluationGenAvg(
          this.getEvaluationSF / this.category[2].mfo_cnt,
          this.category[2].percentage
        );
      }

      return {
        cf,
        sp,
        sf,
      };
    },

    getTotalReviewAvg() {
      let cf = 0;
      let sp = 0;
      let sf = 0;
      let isDesignated = this.category[0].isDesignated;
      if (isDesignated) {
        cf = this.computeEvaluationGenAvg(
          this.computeEvaluationGenAvg(
            this.getReviewCF.instruction,
            this.category[0].total_arr.instruction.percent
          ) +
            this.computeEvaluationGenAvg(
              this.getReviewCF.designation /
                this.category[0].mfo_cnt_div.designation,
              this.category[0].total_arr.designation.percent
            ),
          this.category[0].percentage
        );
        sp = this.computeEvaluationGenAvg(
          this.getReviewSP.researchAndExtension / this.category[1].mfo_cnt,
          this.category[1].percentage
        );
        sf = this.computeEvaluationGenAvg(
          this.getReviewSF / this.category[2].mfo_cnt,
          this.category[2].percentage
        );
      } else {
        cf = this.computeEvaluationGenAvg(
          this.getReviewCF.instruction,
          this.category[0].percentage
        );
        sp =
          this.computeEvaluationGenAvg(
            this.getReviewSP.research / this.category[1].mfo_cnt_div.research,
            this.category[1].total_arr.research.percent
          ) +
          this.computeEvaluationGenAvg(
            this.getReviewSP.extension / this.category[1].mfo_cnt_div.extension,
            this.category[1].total_arr.extension.percent
          );
        sf = this.computeEvaluationGenAvg(
          this.getReviewSF / this.category[2].mfo_cnt,
          this.category[2].percentage
        );
      }

      return {
        cf,
        sp,
        sf,
      };
    },

    getEvaluationCF() {
      let instruction = 0;
      let designation = null;
      let data = this.ipcrData[0].data;
      let total = 0;

      //instruction
      let inst = data[0];
      for (let i = 0; i < inst.data.length; i++) {
        total += !isNaN(this.computeAvg(inst.data[i], inst.data[i].prct))
          ? this.computeAvg(inst.data[i], inst.data[i].prct)
          : 0;
      }
      instruction = total;
      total = 0;
      let desig = data[1];

      if (data[1]) {
        for (let i = 0; i < desig.data.length; i++) {
          total += !isNaN(this.computeAvg(desig.data[i], desig.data[i].prct))
            ? this.computeAvg(desig.data[i])
            : 0;
        }
        designation = total;
      }

      return {
        instruction,
        designation,
      };
    },

    getEvaluationSP() {
      let researchAndExtension = 0;
      let research = null;
      let extension = null;
      let data = this.ipcrData[1].data;
      let total = 0;

      //instruction
      let researchData = data[0];
      console.log("DATA1", data);
      for (let i = 0; i < researchData.data.length; i++) {
        total += !isNaN(
          this.computeAvg(researchData.data[i], researchData.data[i].prct)
        )
          ? this.computeAvg(researchData.data[i], researchData.data[i].prct)
          : 0;
      }
      research = total;
      researchAndExtension = total;
      total = 0;
      let ext = data[1];

      if (data[1]) {
        for (let i = 0; i < ext.data.length; i++) {
          total += !isNaN(this.computeAvg(ext.data[i], ext.data[i].prct))
            ? this.computeAvg(ext.data[i], ext.data[i].prct)
            : 0;
        }
        extension = total;
      }
      researchAndExtension += total;
      extension = total;

      return {
        researchAndExtension,
        research,
        extension,
      };
    },

    getEvaluationSF() {
      let data = this.ipcrData[2].data;
      let total = 0;

      let sf = [...data[0], ...data[1]];
      7;
      for (let i = 0; i < sf.length; i++) {
        total += !isNaN(this.computeAvg(sf[i])) ? this.computeAvg(sf[i]) : 0;
      }

      return total;
    },

    getReviewCF() {
      let instruction = 0;
      let designation = null;
      let data = this.ipcrData[0].data;
      let total = 0;

      //instruction
      let inst = data[0];
      for (let i = 0; i < inst.data.length; i++) {
        if (inst.data[i].hasReview) {
          total += !isNaN(
            this.computeReviewAvg(inst.data[i], inst.data[i].prct)
          )
            ? this.computeReviewAvg(inst.data[i], inst.data[i].prct)
            : 0;
        } else {
          total += !isNaN(this.computeAvg(inst.data[i], inst.data[i].prct))
            ? this.computeAvg(inst.data[i], inst.data[i].prct)
            : 0;
        }
      }
      instruction = total;
      total = 0;
      let desig = data[1];

      if (data[1]) {
        for (let i = 0; i < desig.data.length; i++) {
          if (desig.data[i].hasReview) {
            total += !isNaN(
              this.computeReviewAvg(desig.data[i], desig.data[i].prct)
            )
              ? this.computeReviewAvg(desig.data[i])
              : 0;
          } else {
            total += !isNaN(this.computeAvg(desig.data[i], desig.data[i].prct))
              ? this.computeAvg(desig.data[i])
              : 0;
          }
        }
        designation = total;
      }

      return {
        instruction,
        designation,
      };
    },

    getReviewSP() {
      let researchAndExtension = 0;
      let research = null;
      let extension = null;
      let data = this.ipcrData[1].data;
      let total = 0;

      //instruction
      let researchData = data[0];
      for (let i = 0; i < researchData.data.length; i++) {
        if (researchData.data[i].hasReview) {
          total += !isNaN(
            this.computeReviewAvg(
              researchData.data[i],
              researchData.data[i].prct
            )
          )
            ? this.computeReviewAvg(
                researchData.data[i],
                researchData.data[i].prct
              )
            : 0;
        } else {
          total += !isNaN(
            this.computeAvg(researchData.data[i], researchData.data[i].prct)
          )
            ? this.computeAvg(researchData.data[i], researchData.data[i].prct)
            : 0;
        }
      }
      research = total;
      researchAndExtension = total;
      total = 0;
      let ext = data[1];

      if (data[1]) {
        for (let i = 0; i < ext.data.length; i++) {
          total += !isNaN(this.computeReviewAvg(ext.data[i], ext.data[i].prct))
            ? this.computeReviewAvg(ext.data[i], ext.data[i].prct)
            : 0;
        }
        extension = total;
      }
      researchAndExtension += total;
      extension = total;

      return {
        researchAndExtension,
        research,
        extension,
      };
    },

    getReviewSF() {
      let data = this.ipcrData[2].data;
      let total = 0;

      let sf = [...data[0], ...data[1]];
      7;
      for (let i = 0; i < sf.length; i++) {
        if (sf[i].hasReview) {
          total += !isNaN(this.computeReviewAvg(sf[i]))
            ? this.computeReviewAvg(sf[i])
            : 0;
        } else {
          total += !isNaN(this.computeAvg(sf[i])) ? this.computeAvg(sf[i]) : 0;
        }
      }

      return total;
    },

    getTotal() {
      let total = 0;
      if (this.tab == 1) {
        total = this.category[0].gen_avg;
      }
      if (this.tab == 2) {
        total = this.category[1].gen_avg;
      }
      if (this.tab == 3) {
        total = this.category[2].gen_avg;
      }

      return total;
    },

    getSubTotal() {
      let total;
      if (this.tab == 1 || this.tab == 4) {
        total = {
          instruction: this.formatNumberValue(
            this.category[0].total_arr.instruction.subT,
            2
          ),
          designation: this.category[0].isDesignated
            ? this.formatNumberValue(
                this.category[0].total_arr.designation.subT,
                2
              )
            : null,
          instruction_non_designated: this.formatNumberValue(
            this.category[0].subT,
            2
          ),
        };
      }
      if (this.tab == 2) {
        total = {
          researchAndExtension: this.formatNumberValue(
            this.category[1].subT,
            2
          ),
          research: !this.category[1].isDesignated
            ? this.formatNumberValue(
                this.category[1].total_arr.research.subT,
                2
              )
            : null,
          extension: !this.category[1].isDesignated
            ? this.formatNumberValue(
                this.category[1].total_arr.extension.subT,
                2
              )
            : null,
        };
      }
      if (this.tab == 3) {
        total = {
          sfTotal: this.formatNumberValue(this.category[2].total, 2),
        };
      }

      return total;
    },
    getCFIntruction() {
      let data = [];
      let type = "";
      let percentage = null;
      let prct_display = null;
      if (this.ipcrData) {
        data = this.ipcrData[0].data[0].data;
        type = this.ipcrData[0].data[0].type;
        percentage = this.ipcrData[0].data[0].percentage;
        prct_display = this.ipcrData[0].data[0].prct_display;
      }
      return {
        type,
        percentage,
        prct_display,
        data,
      };
    },
    getCFDesignation() {
      let data = [];
      let type = "";
      let percentage = null;
      let prct_display = null;
      if (this.ipcrData && this.data.facultyType == "designated") {
        data = this.ipcrData[0].data[1].data;
        type = this.ipcrData[0].data[1].type;
        percentage = this.ipcrData[0].data[1].percentage;
        prct_display = this.ipcrData[0].data[1].prct_display;
      }
      return {
        type,
        percentage,
        prct_display,
        data,
      };
    },
    getSPResearch() {
      let data = [];
      let type = "";
      let percentage = null;
      let prct_display = null;
      if (this.ipcrData) {
        data = this.ipcrData[1].data[0].data;
        type = this.ipcrData[1].data[0].type;
        percentage = this.ipcrData[1].data[0].percentage;
        prct_display = this.ipcrData[1].data[0].prct_display;
      }
      return {
        type,
        percentage,
        prct_display,
        data,
      };
    },
    getSPExtension() {
      let data = [];
      let type = "";
      let percentage = null;
      let prct_display = null;
      if (this.ipcrData) {
        data = this.ipcrData[1].data[1].data;
        type = this.ipcrData[1].data[1].type;
        percentage = this.ipcrData[1].data[1].percentage;
        prct_display = this.ipcrData[1].data[1].prct_display;
      }
      return {
        type,
        percentage,
        prct_display,
        data,
      };
    },
    getSFInstOblig() {
      let data = [];
      let type = "";
      let percentage = null;
      let prct_display = null;
      if (this.ipcrData) {
        data = this.ipcrData[2].data[0];
        // type = this.ipcrData[2].data[0].type;
        // percentage = this.ipcrData[2].data[0].percentage;
        // prct_display = this.ipcrData[2].data[0].prct_display;
      }
      return {
        type,
        percentage,
        prct_display,
        data,
      };
    },
    // getSFInterveneFunc() {
    //   let data = [];
    //   let type = "";
    //   let percentage = null;
    //   let prct_display = null;
    //   if (this.ipcrData) {
    //     data = this.ipcrData[2].data[1];
    //     // type = this.ipcrData[2].data[1].type;
    //     // percentage = this.ipcrData[2].data[1].percentage;
    //     // prct_display = this.ipcrData[2].data[1].prct_display;
    //   }
    //   return {
    //     type,
    //     percentage,
    //     prct_display,
    //     data,
    //   };
    // },
    getProfDev() {
      let data = [];
      let type = "";
      let percentage = null;
      let prct_display = null;
      if (this.ipcrData) {
        data = this.ipcrData[2].data[1];
        // type = this.ipcrData[2].data[2].type;
        // percentage = this.ipcrData[2].data[2].percentage;
        // prct_display = this.ipcrData[2].data[2].prct_display;
      }
      return {
        type,
        percentage,
        prct_display,
        data,
      };
    },
    getSF1Len() {
      let len = 0;

      for (let i = 0; i < this.ipcrToView.data.sf1.data.length; i++) {
        if (this.ipcrToView.data.sf1.data[i].addToSF1Divisor) {
          len++;
        }
      }

      return len;
    },

    getIsPendingByApprovers() {
      return this.assessed_by_status == 3 || this.final_rating_by_status == 3;
    },
    getHasUnsavedRemarks() {
      return this.unsavedRemarksList.length > 0;
    },
  },

  data() {
    return {
      category: [],
      remarksData: [],
      confirmSubmitDialog: false,
      confirmDialog: false,
      itemToDelete: null,
      confirmBtnLoading: false,
      options: {},
      action: null,
      fadeAwayMessage: {
        show: false,
        type: "success",
        header: "Successfully Added!",
        message: "",
        top: 10,
      },
      mporData: [],
      dialog: false,
      activeTab: { id: 1, name: "Core Functions" },
      tab: 1,
      tabList: [
        { id: 1, name: "Core Functions" },
        { id: 2, name: "Strategic Priority" },
        { id: 3, name: "Support Functions" },
        { id: 4, name: "Category" },
        { id: 5, name: "Evidences" },
      ],
      ipcrData: null,
      ipcrToView: null,
      id: null,
      isSubmitted: null,
      dataItem: [],
      isButtonLoading: false,
      assessed_by: null,
      assessed_by_status: null,
      final_rating_by: null,
      final_rating_by_status: null,
      //   headers: [
      //     {
      //       text: "MFO",
      //       value: "mfo",
      //       align: "start",
      //       valign: "start",
      //       sortable: false,
      //     },
      //     {
      //       text: "Efficiency",
      //       value: "efficiency",
      //       align: "center",
      //       valign: "center",
      //       sortable: false,
      //     },
      //     {
      //       text: "Quality",
      //       value: "quality",
      //       align: "center",
      //       valign: "center",
      //       sortable: false,
      //     },
      //     {
      //       text: "Timeliness",
      //       value: "timeliness",
      //       align: "center",
      //       valign: "center",
      //       sortable: false,
      //     },

      //     {
      //       text: "To be Rated",
      //       value: "eqt",
      //       align: "center",
      //       valign: "center",
      //       sortable: false,
      //     },
      //     {
      //       text: "Action",
      //       value: "action",
      //       align: "end",
      //     },
      //   ],
      //   support_headers: [
      //     {
      //       text: "Type",
      //       value: "type",
      //       align: "start",
      //       valign: "start",
      //       sortable: false,
      //     },
      //     {
      //       text: "Success Indicator",
      //       value: "success_indicator",
      //       align: "center",
      //       width: 250,
      //       valign: "center",
      //       sortable: false,
      //     },

      //     {
      //       text: "To be Rated",
      //       value: "eqt",
      //       align: "center",
      //       valign: "center",
      //       sortable: false,
      //     },
      //     {
      //       text: "Action",
      //       value: "action",
      //       align: "end",
      //     },
      //   ],
      headers: [
        {
          text: "GDrive Link",
          value: "link",
          align: "start",
          valign: "center",
        },

        {
          text: "Actions",
          value: "actions",
          align: "center",
          valign: "center",
          sortable: false,
          width: 100,
        },
      ],
      evidenceList: [],
      unsavedRemarksList: [],
      addEvalDialog: false,
      isEvaluating: false,
      bottom_actions: false,
      addedEvaluations: [],
      eval_efficiency: null,
      eval_quality: null,
      eval_timeliness: null,
      eval_efficiency_rated: true,
      eval_quality_rated: true,
      eval_timeliness_rated: true,
      eval_remarks: null,
      targetToEvaluate: null,
      rowIdx: null,
      sfType: null,
      warningMsg: null,
      confirmType: null,
      btnLoading: false,
      ipcrER_id: null,
      isSubmitLoading: false,
      typeToEdit: null,
    };
  },
  watch: {
    data: {
      handler(data) {
        this.dialog = true;
        this.activeTab = { id: 1, name: "Core Functions" };
        console.log("IPCR", data);
        this.ipcrER_id = data.ipcrER_id;
        this.id = data.id;
        this.assessed_by_status = data.assesed_by_status;
        this.final_rating_by_status = data.final_rating_by_status;
        this.isSubmitted = data.isSubmitted;
        this.tab = 1;
        this.initialize();
      },
      deep: true,
    },
    shouldPreventRefresh: {
      deep: true,
      handler(shouldPrevent) {
        if (shouldPrevent) {
          window.addEventListener("beforeunload", this.handleBeforeUnload);
        } else {
          window.removeEventListener("beforeunload", this.handleBeforeUnload);
        }
      },
    },
    options: {
      handler() {
        this.initialize();
      },
      deep: true,
    },
  },
  mounted() {},

  beforeDestroy() {
    window.removeEventListener("beforeunload", this.handleBeforeUnload);
  },

  methods: {
    handleBeforeUnload(e) {
      e.preventDefault();
      e.returnValue = "";
      return "";
    },

    getAddEvaluationBtnText(item) {
      if (this.moduleFrom == "Review") {
        return item.hasReview ? "Edit" : "Add";
      } else {
        return item.hasEvaluation ? "Edit" : "Add";
      }
    },

    getRatingEquivalent(val) {
      let equivalent = "";
      if (parseFloat(val) <= 5 && parseFloat(val) >= 4.2) {
        equivalent = "Outstanding";
      } else if (parseFloat(val) <= 4.19 && parseFloat(val) >= 3.4) {
        equivalent = "Very Satisfactory";
      } else if (parseFloat(val) <= 3.39 && parseFloat(val) >= 2.6) {
        equivalent = "Satisfactory";
      } else if (parseFloat(val) <= 2.59 && parseFloat(val) >= 1.8) {
        equivalent = "Unsatisfactory";
      } else {
        equivalent = "Poor";
      }
      return equivalent;
    },

    computeAvg(item, prct) {
      let divisor = 0;
      let e = 0;
      let q = 0;
      let t = 0;
      if (item.hasEvaluation) {
        if (item.e_avg != "NR") {
          if (item.evaluation.efficiency) {
            e = parseFloat(item.evaluation.efficiency);
          } else {
            e = parseFloat(item.e_avg);
          }
          divisor++;
        }
        if (item.q_avg != "NR") {
          if (item.evaluation.quality) {
            q = parseFloat(item.evaluation.quality);
          } else {
            q = parseFloat(item.q_avg);
          }
          divisor++;
        }
        if (item.t_avg != "NR") {
          if (item.evaluation.timeliness) {
            t = parseFloat(item.evaluation.timeliness);
          } else {
            t = parseFloat(item.t_avg);
          }
          divisor++;
        }
      } else {
        if (item.e_avg != "NR") {
          e = parseFloat(item.e_avg);
          divisor++;
        }
        if (item.q_avg != "NR") {
          q = parseFloat(item.q_avg);
          divisor++;
        }
        if (item.t_avg != "NR") {
          t = parseFloat(item.t_avg);
          divisor++;
        }
      }
      if (prct) {
        return ((e + q + t) / divisor) * parseFloat(prct);
      }
      return (e + q + t) / divisor;
    },

    computeReviewAvg(item, prct) {
      let divisor = 0;
      let e = 0;
      let q = 0;
      let t = 0;
      if (item.hasReview) {
        if (item.e_avg != "NR") {
          if (item.review.efficiency) {
            e = parseFloat(item.review.efficiency);
          } else {
            if (item.evaluation.efficiency) {
              e = parseFloat(item.evaluation.efficiency);
            } else {
              e = parseFloat(item.e_avg);
            }
          }

          divisor++;
        }
        if (item.q_avg != "NR") {
          if (item.review.quality) {
            q = parseFloat(item.review.quality);
          } else {
            if (item.evaluation.quality) {
              q = parseFloat(item.evaluation.quality);
            } else {
              q = parseFloat(item.q_avg);
            }
          }
          divisor++;
        }
        if (item.t_avg != "NR") {
          if (item.review.timeliness) {
            t = parseFloat(item.review.timeliness);
          } else {
            if (item.evaluation.timeliness) {
              t = parseFloat(item.evaluation.timeliness);
            } else {
              t = parseFloat(item.t_avg);
            }
          }
          divisor++;
        }
      } else {
        if (item.hasEvaluation) {
          if (item.e_avg != "NR") {
            if (item.evaluation.efficiency) {
              e = parseFloat(item.evaluation.efficiency);
            } else {
              e = parseFloat(item.e_avg);
            }
            divisor++;
          }
          if (item.q_avg != "NR") {
            if (item.evaluation.efficiency) {
              q = parseFloat(item.evaluation.quality);
            } else {
              q = parseFloat(item.q_avg);
            }

            divisor++;
          }
          if (item.t_avg != "NR") {
            if (item.evaluation.efficiency) {
              t = parseFloat(item.evaluation.timeliness);
            } else {
              t = parseFloat(item.t_avg);
            }
            divisor++;
          }
        } else {
          if (item.e_avg != "NR") {
            e = parseFloat(item.e_avg);
            divisor++;
          }
          if (item.q_avg != "NR") {
            q = parseFloat(item.q_avg);
            divisor++;
          }
          if (item.t_avg != "NR") {
            t = parseFloat(item.t_avg);
            divisor++;
          }
        }
      }
      if (prct) {
        return ((e + q + t) / divisor) * parseFloat(prct);
      }
      return (e + q + t) / divisor;
    },

    computeEvaluationGenAvg(avg, prct_str) {
      const percent = prct_str.replace("%", "");
      const numberValue = parseFloat(percent) / 100;

      return avg * numberValue;
    },

    initialize() {
      this.loadRemarks(this.id);
      this.loading = true;
      this.axiosCall("/ipcr/getIPCRForEvaluationById/" + this.id, "GET").then(
        (res) => {
          if (res) {
            console.log("IPCR DATAasdasd", res.data);
            this.ipcrData = res.data.ipcr.data;
            this.category = res.data.ipcr.category;
            this.ipcrER_id = res.data.hasEvaluationData
              ? res.data.hasEvaluationData.id
              : null;
            // console.log("ipcrtoview", res.data.data[this.tab - 1]);
            if (this.tab != 4) {
              this.ipcrToView = res.data.ipcr.data[this.tab - 1];
            }
            this.evidenceList = res.data.evidences;

            this.loading = false;
          }
        }
      );
    },

    submitIPCR() {
      this.confirmSubmitDialog = true;
    },

    cancelConfirm() {
      this.confirmSubmitDialog = false;
    },

    confirmSubmit() {
      this.confirmBtnLoading = true;
      this.axiosCall("/ipcr/submitMyIPCR/" + this.id, "PATCH").then((res) => {
        if (res.data.status == 200) {
          this.confirmBtnLoading = false;
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "success";
          this.fadeAwayMessage.header = "System Message";
          this.fadeAwayMessage.message = res.data.msg;
          this.closeD();
        } else if (res.data.status == 400) {
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "error";
          this.fadeAwayMessage.header = "System Message";
          this.fadeAwayMessage.message = res.data.msg;
        }
      });
    },

    addRemarks(item, type) {
      console.log(item, type);
    },

    loadRemarks(id) {
      if (id) {
        this.axiosCall("/remarks/" + id + "/IPCR", "GET").then((res) => {
          if (res.data) {
            // console.log("remarks", res.data);
            this.remarksData = res.data;
          }
        });
      }
    },
    closeD() {
      if (this.shouldPreventRefresh) {
        this.fadeAwayMessage.show = true;
        this.fadeAwayMessage.type = "error";
        this.fadeAwayMessage.header = "System Message";
        this.fadeAwayMessage.timeout = 5000;
        this.fadeAwayMessage.message =
          "You have unsaved changes, please click the ACTIONS button below to show save button.";
      } else {
        this.eventHub.$emit("closeCECFacultyDialog", false);
        this.confirmSubmitDialog = false;
        this.confirmBtnLoading = false;
        this.isSubmitLoading = false;
        this.dialog = false;
      }
    },
    edit(item) {
      if (this.tab != 3) {
        this.ipcrData = item;
        this.action = "Update";
      } else {
        this.ipcrSupData = item;
        this.action = "Update";
      }
    },

    computeGeneralAve(data, percentage) {
      let avg = 0;
      if (percentage != 0) {
        if (data.data.length) {
          avg = ((data.total / data.data.length) * percentage).toFixed(2);
        } else {
          avg = (data.total * percentage).toFixed(2);
        }
        return avg;
      } else {
        return 0.0;
      }
    },

    getOverAllrating() {
      let total = 0;
      for (let i = 0; i < this.ipcrData.length; i++) {
        let d = this.computeGeneralAve(
          this.ipcrData[i],
          this.ipcrData[i].func_type != "Support Function"
            ? this.ipcrData[i].func_type == "Core Function"
              ? this.ipcrData[1].data.length > 0
                ? 0.6
                : 0.9
              : this.ipcrData[1].data.length > 0
              ? 0.3
              : 0
            : 0.1
        );
        total += parseFloat(d);
      }
      return total.toFixed(2);
    },

    closeEvalDialog() {
      this.targetToEvaluate = null;
      this.rowIdx = null;
      this.typeToEdit = null;
      this.addEvalDialog = false;
    },

    changeTab(tab) {
      this.activeTab = tab;
      this.tab = tab.id;
      if (this.tab != 4) {
        this.ipcrToView = this.ipcrData[this.tab - 1];
      }
    },
    yes() {
      this.btnLoading = true;

      if (this.confirmType == "Save Evaluation") {
        this.saveEvaluation();
      }
      if (this.confirmType == "Submit For Review") {
        this.saveForReview();
      }
      if (this.confirmType == "Submit As Reviewed") {
        this.saveAsReviewed();
      }
      if (this.confirmType == "Cancel Evaluation") {
        this.cancelEvaluation();
      }
    },
    no() {
      this.warningMsg = null;
      this.confirmType = null;
    },

    add_evaluation(type, item, index, sfType) {
      console.log("ITEMS", type, item, index, sfType);
      this.eval_efficiency_rated = item.e_avg == "NR";
      this.eval_quality_rated = item.q_avg == "NR";
      this.eval_timeliness_rated = item.t_avg == "NR";
      this.sfType = sfType;
      if (this.moduleFrom == "Review") {
        if (item.review) {
          this.eval_efficiency = item.review.efficiency;
          this.eval_quality = item.review.quality;
          this.eval_timeliness = item.review.timeliness;
          this.eval_remarks = item.review.remarks;
        } else {
          this.eval_efficiency = null;
          this.eval_quality = null;
          this.eval_timeliness = null;
          this.eval_remarks = null;
        }
      } else {
        if (item.evaluation) {
          this.eval_efficiency = item.evaluation.efficiency;
          this.eval_quality = item.evaluation.quality;
          this.eval_timeliness = item.evaluation.timeliness;
          this.eval_remarks = item.evaluation.remarks;
        } else {
          this.eval_efficiency = null;
          this.eval_quality = null;
          this.eval_timeliness = null;
          this.eval_remarks = null;
        }
      }

      this.rowIdx = index;
      this.typeToEdit = type;
      this.targetToEvaluate = item;
      this.$refs.AddEvalFormRef.resetValidation();
      this.addEvalDialog = true;
    },

    saveEval() {
      if (this.$refs.AddEvalFormRef.validate()) {
        let trgt_type =
          this.tab == 1
            ? "Core Function"
            : this.tab == 2
            ? "Strategic Priority"
            : this.tab == 3
            ? "Support Function"
            : "";
        let data = {
          efficiency: this.eval_efficiency,
          quality: this.eval_quality,
          timeliness: this.eval_timeliness,
          remarks: this.eval_remarks,
          trgt_type: trgt_type,
          trgt_id:
            this.tab != 3
              ? this.targetToEvaluate.ipcrTargetId
              : this.targetToEvaluate.supportId,
        };
        this.addedEvaluations.push(data);
        this.insertEvaluation(data);
        this.closeEvalDialog();
      }
    },

    insertEvaluation(data) {
      if (this.tab == 1) {
        let idx = this.ipcrData[0].data[
          this.typeToEdit == "Instruction" ? 0 : 1
        ].data.findIndex(
          (data) => data.ipcrTargetId === this.targetToEvaluate.ipcrTargetId
        );

        if (this.moduleFrom == "Review") {
          this.ipcrData[0].data[this.typeToEdit == "Instruction" ? 0 : 1].data[
            idx
          ].hasReview = true;
          this.ipcrData[0].data[this.typeToEdit == "Instruction" ? 0 : 1].data[
            idx
          ].review = data;
        } else {
          this.ipcrData[0].data[this.typeToEdit == "Instruction" ? 0 : 1].data[
            idx
          ].hasEvaluation = true;
          this.ipcrData[0].data[this.typeToEdit == "Instruction" ? 0 : 1].data[
            idx
          ].evaluation = data;
        }
      }
      if (this.tab == 2) {
        let idx = this.ipcrData[1].data[
          this.typeToEdit == "Research" ? 0 : 1
        ].data.findIndex(
          (data) => data.ipcrTargetId === this.targetToEvaluate.ipcrTargetId
        );
        if (this.moduleFrom == "Review") {
          this.ipcrData[1].data[this.typeToEdit == "Research" ? 0 : 1].data[
            idx
          ].hasReview = true;
          this.ipcrData[1].data[this.typeToEdit == "Research" ? 0 : 1].data[
            idx
          ].review = data;
        } else {
          this.ipcrData[1].data[this.typeToEdit == "Research" ? 0 : 1].data[
            idx
          ].hasEvaluation = true;
          this.ipcrData[1].data[this.typeToEdit == "Research" ? 0 : 1].data[
            idx
          ].evaluation = data;
        }
      }
      if (this.tab == 3) {
        if (this.moduleFrom == "Review") {
          if (this.typeToEdit == "Institutional Obligations") {
            let idx = this.ipcrData[2].data[0].findIndex(
              (data) => data.supportId === this.targetToEvaluate.supportId
            );

            this.ipcrData[2].data[0][idx].hasReview = true;
            this.ipcrData[2].data[0][idx].review = data;
          }
          if (this.typeToEdit == "Professional Development") {
            let idx = this.ipcrData[2].data[1].findIndex(
              (data) => data.supportId === this.targetToEvaluate.supportId
            );

            this.ipcrData[2].data[1][idx].hasReview = true;
            this.ipcrData[2].data[1][idx].review = data;
          }
        } else {
          if (this.typeToEdit == "Institutional Obligations") {
            let idx = this.ipcrData[2].data[0].findIndex(
              (data) => data.supportId === this.targetToEvaluate.supportId
            );

            this.ipcrData[2].data[0][idx].hasEvaluation = true;
            this.ipcrData[2].data[0][idx].evaluation = data;
          }
          if (this.typeToEdit == "Professional Development") {
            let idx = this.ipcrData[2].data[1].findIndex(
              (data) => data.supportId === this.targetToEvaluate.supportId
            );

            this.ipcrData[2].data[1][idx].hasEvaluation = true;
            this.ipcrData[2].data[1][idx].evaluation = data;
          }
        }
      }
      console.log(this.ipcrData);
    },

    saveEvaluation() {
      if (this.addedEvaluations.length > 0) {
        let data = {
          ipcrID: this.id,
          evaluations: JSON.stringify(this.addedEvaluations),
        };
        let url =
          this.moduleFrom == "Review"
            ? "/ipcr/saveAddedReviews"
            : "/ipcr/saveAddedEvaluations";
        this.axiosCall(url, "POST", data).then((res) => {
          if (res.data.status == 201) {
            this.warningMsg = null;
            this.addedEvaluations = [];
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "success";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message = res.data.msg;
            this.isEvaluating = false;
            this.initialize();
          } else {
            this.warningMsg = null;
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "error";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message = res.data.msg;
          }
        });
      } else {
        this.fadeAwayMessage.show = true;
        this.fadeAwayMessage.type = "error";
        this.fadeAwayMessage.header = "System Message";
        this.fadeAwayMessage.message = "No added evaluations yet!";
      }
    },

    cancelEvaluation() {
      this.isEvaluating = false;
      this.addedEvaluations = [];

      this.warningMsg = null;
      this.fadeAwayMessage.show = true;
      this.fadeAwayMessage.type = "success";
      this.fadeAwayMessage.header = "System Message";
      this.fadeAwayMessage.message = "Cancelled successfully!";
      this.initialize();
    },

    saveForReview() {
      this.bottom_actions = false;

      this.axiosCall("/ipcr/submitEvaluation/" + this.ipcrER_id, "PATCH").then(
        (res) => {
          if (res.data.status == 200) {
            this.warningMsg = null;
            this.addedEvaluations = [];
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "success";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message = res.data.msg;
            this.closeD();
          } else {
            this.warningMsg = null;
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "error";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message = res.data.msg;
          }
        }
      );
    },

    saveAsReviewed() {
      this.bottom_actions = false;

      this.axiosCall("/ipcr/submitReviewed/" + this.id, "PATCH").then((res) => {
        if (res.data.status == 200) {
          this.warningMsg = null;
          this.addedEvaluations = [];
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "success";
          this.fadeAwayMessage.header = "System Message";
          this.fadeAwayMessage.message = res.data.msg;
          this.closeD();
        } else {
          this.warningMsg = null;
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "error";
          this.fadeAwayMessage.header = "System Message";
          this.fadeAwayMessage.message = res.data.msg;
        }
      });
    },

    confirmSave(type) {
      this.confirmType = type;

      if (type == "Save Evaluation") {
        this.btnLoading = true;
        this.warningMsg = "Are you sure you want to save added evaluations?";
      }

      if (type == "Submit For Review") {
        this.warningMsg =
          "Are you sure you want to submit this IPCR for REVIEW?";
      }

      if (type == "Submit As Reviewed") {
        this.warningMsg =
          "Are you sure you want to submit this IPCR as REVIEWED?";
      }

      if (type == "Cancel Evaluation") {
        if (this.addedEvaluations.length > 0) {
          this.warningMsg =
            "You have unsaved evaluations, Are you sure you want to CANCEL this?";
        } else {
          this.isEvaluating = false;
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "success";
          this.fadeAwayMessage.header = "System Message";
          this.fadeAwayMessage.message = "Cancelled successfully!";
        }
      }
    },
    viewLink(item) {
      let url = item.link;
      window.open(url, "_blank");
    },
    printIPCR() {
      console.log(this.data);
      let url;
      if (this.data.isFaculty == 0) {
        url =
          process.env.VUE_APP_SERVER +
          "/pdf-generator/generateIPCRForm/IPCR/" +
          this.data.id;
      } else {
        url =
          process.env.VUE_APP_SERVER +
          "/pdf-generator/facultyIPCR/IPCR/" +
          this.data.id;
      }

      let token = localStorage.getItem("token");
      this.isLoading = true;
      const tab = window.open("about:blank");
      fetch(url, { headers: { Authorization: `Bearer ${token}` } }) // FETCH BLOB FROM IT
        .then((response) => response.blob())
        .then((blob) => {
          // RETRIEVE THE BLOB AND CREATE LOCAL URL
          var _url = window.URL.createObjectURL(blob);

          // window.open(_url, "_blank").focus();
          tab.location = _url;
          tab.focus();
          this.isLoading = false; // window.open + focus
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
<style scoped>
#ipcrTable,
#categoryTable {
  width: 100%;
  border-collapse: collapse;
}
#ipcrTable td,
#ipcrTable th,
#categoryTable td,
#categoryTable th {
  border: 1px solid grey;
}
.preserve-whitespace {
  white-space: pre-line;
  word-wrap: break-word;
}
</style>
